import { useUrlFilters } from "../useUrlFilters";

const STUDENT_FILTER_CONFIG = {
  studentName: {
    key: "name",
    defaultValue: "",
    parse: (value: string | null) => value || "",
    serialize: (value: string) => value || null,
  },
  classId: {
    key: "class",
    defaultValue: null as number | null,
    parse: (value: string | null) => (value ? Number(value) : null),
    serialize: (value: number | null) => (value ? String(value) : null),
  },
  branchId: {
    key: "branch",
    defaultValue: null as number | null,
    parse: (value: string | null) => (value ? Number(value) : null),
    serialize: (value: number | null) => (value ? String(value) : null),
  },
  page: {
    key: "page",
    defaultValue: 1,
    parse: (value: string | null) => (value ? Number(value) : 1),
    serialize: (value: number) => (value ? String(value) : null),
  },
} as const;

export const useStudentListFilters = (namespace: string) => {
  return useUrlFilters(namespace, STUDENT_FILTER_CONFIG);
};
